<section>
    <div class="card">
        <div class="card-header">Import</div>
        <div class="card-body">
            <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
                <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" class="customWrapper">
                  <div fxFlex="25" fxFlex.gt-sm="25">
                    <mat-form-field floatLabel="always" appearance="outline">
                      <mat-label>Date </mat-label>
                      <input matInput value="{{import?.ImportDate | date:'dd/MM/yyyy HH:mm:ss' }}" type="text" readonly disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="25" fxFlex.gt-sm="25">
                    <mat-form-field floatLabel="always" appearance="outline">
                      <mat-label>Fichiers </mat-label>
                      <input matInput value="{{import?.FilesCount }}" type="text" readonly disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="25" fxFlex.gt-sm="25">
                    <mat-form-field floatLabel="always" appearance="outline">
                      <mat-label>Erreurs </mat-label>
                      <input matInput value="{{import?.Errors }}" type="text" readonly disabled>
                    </mat-form-field>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-table [data]="details" [tableActions]="tableActions" [tableIndications]="tableIndications"
    [showClearFilterButton]="true" [exportFileName]="exportFileName" [columnsDefinition]="columnsDefinition"
    [configKey]="configKey" ngDefaultControl>
</app-table>

<div class="d-flex justify-content-center">
    <div class="col-2">
        <button mat-stroked-button class="currentBtnColor" matTooltip="Retour" (click)="onBack()">
            <mat-icon>keyboard_return</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Retour</span>
        </button>
    </div>
</div>